import { createContext } from "react";

const TicketsContext = createContext();

export default TicketsContext;